<div class="lbl">
  <div class="lbl__head">
    <div>
      <span class="lbl__eyebrow">{{ data.reference ? '#' + data.reference : 'Szállítás' }}</span>
      <h2>{{ title }}</h2>
    </div>
    <button type="button" class="stk-icon-btn" (click)="cancel()" aria-label="Bezárás">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
    </button>
  </div>

  <!-- UPS -->
  <div class="lbl__body">
    <div class="lbl__note" *ngIf="upsLoading">Adatok betöltése…</div>

    <div class="lbl__alert lbl__alert--warn" *ngIf="upsInfo && !upsInfo.configured">
      A UPS még nincs beállítva. Beállítások → UPS: Client ID, Client Secret, fiókszám és feladó cím.
    </div>

    <ng-container *ngIf="draft && upsInfo?.configured">
      <div class="lbl__alert lbl__alert--warn" *ngIf="upsInfo?.existingLabel?.trackingCode">
        Már van címke ({{ upsInfo?.existingLabel?.provider === 'ups' ? 'UPS' : 'Spring/egyéb' }}: {{ upsInfo?.existingLabel?.trackingCode }}).
        {{ upsInfo?.existingLabel?.provider === 'ups' ? 'Az új UPS címkénél a régit automatikusan sztornózzuk.' : 'A régi küldeményt a ShippyPro-ban kézzel töröld, ha nem adod fel.' }}
      </div>
      <ul class="lbl__warnings" *ngIf="upsInfo?.warnings?.length">
        <li *ngFor="let w of upsInfo?.warnings">{{ w }}</li>
      </ul>

      <section class="lbl__section">
        <div class="lbl__kicker">Címzett</div>
        <div class="lbl__grid">
          <label class="lbl__f lbl__f--wide"><span class="stk-label">Név</span><input class="stk-input" [(ngModel)]="draft.recipient['name']" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f lbl__f--wide"><span class="stk-label">Utca, házszám</span><input class="stk-input" [(ngModel)]="draft.recipient['street1']" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f lbl__f--wide"><span class="stk-label">Cím 2. sor</span><input class="stk-input" [(ngModel)]="draft.recipient['street2']" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f"><span class="stk-label">Irányítószám</span><input class="stk-input" [(ngModel)]="draft.recipient['zip']" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f"><span class="stk-label">Város</span><input class="stk-input" [(ngModel)]="draft.recipient['city']" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f"><span class="stk-label">Állam / megye kód</span><input class="stk-input" [(ngModel)]="draft.recipient['state']" (ngModelChange)="markDirty()" placeholder="pl. NY"></label>
          <label class="lbl__f"><span class="stk-label">Ország (ISO)</span><input class="stk-input" maxlength="2" [(ngModel)]="draft.recipient['country']" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f"><span class="stk-label">Telefon</span><input class="stk-input" [(ngModel)]="draft.recipient['phone']"></label>
          <label class="lbl__f"><span class="stk-label">E-mail</span><input class="stk-input" [(ngModel)]="draft.recipient['email']"></label>
        </div>
      </section>

      <section class="lbl__section">
        <div class="lbl__kicker">Csomag <span *ngIf="draft.package.packageType">· {{ draft.package.packageType }}</span></div>
        <div class="lbl__grid lbl__grid--4">
          <label class="lbl__f"><span class="stk-label">Súly (kg)</span><input class="stk-input" type="number" step="0.01" min="0.1" [(ngModel)]="draft.package.weightKg" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f"><span class="stk-label">Hossz (cm)</span><input class="stk-input" type="number" min="1" [(ngModel)]="draft.package.lengthCm" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f"><span class="stk-label">Szél. (cm)</span><input class="stk-input" type="number" min="1" [(ngModel)]="draft.package.widthCm" (ngModelChange)="markDirty()"></label>
          <label class="lbl__f"><span class="stk-label">Mag. (cm)</span><input class="stk-input" type="number" min="1" [(ngModel)]="draft.package.heightCm" (ngModelChange)="markDirty()"></label>
        </div>
      </section>

      <section class="lbl__section" *ngIf="draft.customsRequired">
        <div class="lbl__kicker">Vám · Commercial Invoice</div>
        <div class="lbl__grid">
          <label class="lbl__f"><span class="stk-label">Vámot fizeti</span>
            <select class="stk-input" [(ngModel)]="draft.dutyPayer" (ngModelChange)="markDirty()">
              <option value="receiver">Címzett (DAP)</option>
              <option value="shipper">Feladó (DDP)</option>
            </select>
          </label>
          <label class="lbl__f"><span class="stk-label">Export oka</span><input class="stk-input" maxlength="20" [(ngModel)]="draft.reasonForExport"></label>
        </div>
        <div class="lbl__lines">
          <div class="lbl__line" *ngFor="let line of draft.lines; let i = index; trackBy: trackLine">
            <div class="lbl__line-sku">{{ line.sku || (i + 1) + '. tétel' }}</div>
            <label class="lbl__f lbl__f--desc"><span class="stk-label">Leírás (angol)</span><input class="stk-input" maxlength="35" [(ngModel)]="line.description"></label>
            <label class="lbl__f"><span class="stk-label">HS kód</span><input class="stk-input" [class.lbl__bad]="!line.hsCode" [(ngModel)]="line.hsCode" placeholder="9503000090"></label>
            <label class="lbl__f lbl__f--num"><span class="stk-label">Db</span><input class="stk-input" type="number" min="1" [(ngModel)]="line.quantity" (ngModelChange)="markDirty()"></label>
            <label class="lbl__f lbl__f--num"><span class="stk-label">Egységár ({{ draft.currency }})</span><input class="stk-input" type="number" step="0.01" min="0" [(ngModel)]="line.unitValue" (ngModelChange)="markDirty()"></label>
            <label class="lbl__f lbl__f--num"><span class="stk-label">Súly/db (kg)</span><input class="stk-input" type="number" step="0.001" min="0" [(ngModel)]="line.unitWeightKg"></label>
            <label class="lbl__save" *ngIf="line.componentId">
              <input type="checkbox" [(ngModel)]="line.saveToComponent">
              <span>HS kód és leírás mentése a termékhez</span>
            </label>
          </div>
        </div>
        <div class="lbl__total">Deklarált érték: <strong>{{ declaredTotal | number:'1.2-2' }} {{ draft.currency }}</strong></div>
      </section>
      <div class="lbl__note" *ngIf="!draft.customsRequired">EU-n belüli küldemény — vámáru-számla nem kell.</div>

      <section class="lbl__section">
        <div class="lbl__kicker">Szolgáltatás és ár</div>
        <div class="lbl__rates" *ngIf="rates?.length">
          <label class="lbl__rate" *ngFor="let rate of rates" [class.lbl__rate--on]="selectedService === rate.serviceCode">
            <input type="radio" name="ups-service" [value]="rate.serviceCode" [(ngModel)]="selectedService">
            <span class="lbl__rate-name">{{ rate.serviceName }}</span>
            <span class="lbl__rate-days">{{ rate.businessDays ? rate.businessDays + ' munkanap' : '' }}{{ rate.deliveryBy ? ' · ' + rate.deliveryBy : '' }}</span>
            <span class="lbl__rate-price">
              {{ rate.total | number:'1.2-2' }} {{ rate.currency }}
              <small *ngIf="rate.negotiated && rate.listTotal">lista: {{ rate.listTotal | number:'1.2-2' }}</small>
            </span>
          </label>
        </div>
        <div class="lbl__note" *ngIf="ratesStale">Módosítottál az adatokon — kérd le újra az árat.</div>
        <button type="button" class="stk-btn stk-btn--ghost" (click)="fetchRates()" [disabled]="busy">
          {{ busy && !selectedRate ? 'Lekérés…' : rates ? 'Árak frissítése' : 'Árak lekérése' }}
        </button>
      </section>
    </ng-container>
  </div>

  <div class="lbl__alert lbl__alert--error" *ngIf="error">{{ error }}</div>

  <div class="lbl__actions">
    <button type="button" class="stk-btn stk-btn--ghost" (click)="cancel()" [disabled]="busy">Mégse</button>
    <button type="button" class="stk-btn stk-btn--dark lbl__confirm" (click)="createUps()"
            [disabled]="busy || !draft || !upsInfo?.configured || !selectedRate || ratesStale || hsMissing">
      {{ busy && selectedRate ? 'Készül…' : 'UPS címke létrehozása' }}
      <span *ngIf="selectedRate && !busy">· {{ selectedRate.total | number:'1.2-2' }} {{ selectedRate.currency }}</span>
    </button>
  </div>
</div>
